import { useContext } from "react";
import { LayoutContext } from "../contexts/LayoutContext";

export const useLayout = () => {
    const context = useContext(LayoutContext);
    if (context === undefined) {
        throw new Error("useLayout deve ser usado dentro de um LayoutProvider");
    }
    return context;
};
